import { render, staticRenderFns } from "./HighTerps.vue?vue&type=template&id=1b84c8e8"
import script from "./HighTerps.vue?vue&type=script&lang=js"
export * from "./HighTerps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports